import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import HowToUse from "./components/HowToUse";
import Home from "./components/Home";
import ConfirmEmail from "./components/ConfirmEmail";
import ResetPassword from "./components/ResetPassword";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              <img src="/logo.svg" alt="PuckStats" className="nav-logo-img" />
              PuckStats
            </Link>
            <div className="nav-menu">
              <Link to="/" className="nav-link">
                Home
              </Link>
              <Link to="/how-to-use" className="nav-link">
                How to Use
              </Link>
              <Link to="/privacy-policy" className="nav-link">
                Privacy Policy
              </Link>
            </div>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-to-use" element={<HowToUse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </main>

        <footer className="footer">
          <div className="footer-content">
            <p>&copy; 2025 PuckStats. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
